 <template>
  <el-dialog 
    title="คำร้องขอแก้ไขข้อมูลรายการส่งเสริมการขาย" 
    :visible.sync="show" 
    :before-close="handleClose">
    <el-form :model="form">
      <el-form-item label="รหัสรายการส่งเสริมการขาย">
        <el-input v-model="form.promotion_code" readonly></el-input>
      </el-form-item>
      <el-form-item label="คำอธิบายการแก้ไขข้อมูล" >
        <el-input type="textarea" maxlength="250" show-word-limit :rows="5" v-model="form.cr_remark" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()">ยกเลิก</el-button>
      <el-button type="primary" @click="confirm()">ส่งคำร้อง</el-button>
    </span>
  </el-dialog>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      labelPosition: "top",
      show: false,
      month: [],
      styleOption: {
        textAlign: 'left',
        width: '50%',
        verticalAlign: 'top'
      },
      styleCaption: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'bold'
      },
      form: {
        cr_remark: '',
        promotion_code: '',
        promotion_id: '',
        cr_status: '',
      }
    };
  },
  watch: {
    requestDialog() {
      this.show = this.requestDialog
      this.form.promotion_code = this.info.promotion_code
      this.form.promotion_id = this.info.promotion_id
      this.form.promotion_name_th = this.info.promotion_name_th
      this.form.cr_status = 'request'
      this.form.cr_remark = ''
      this.form.revision_id = this.info.revision_id
      this.form.regulate_id = this.info.regulate_id
    }
  },
  props: ["info", "requestDialog"],
  methods: {
    handleClose() {
      this.$emit("checkModal", false);
    },
    confirm(){
      this.$emit("confirm", this.form)
      this.$emit("checkModal", false)
    }
  }
};
</script>
 